import { useQuery } from "@tanstack/react-query";
import { fetchExtendedDirectoryByLocation, buildExtendedDirectoryParams } from "../fetch/fetchExtendedDirectoryByLocation";

export const extendedDirectoryKey = (input) => {
  const p = buildExtendedDirectoryParams(input);
  return ["extendedDirectoryByLocation", p.project, p.gc, p.maxCounter, p.lac ?? null, p.pos ?? null];
};

export const useGetExtendedDirectoryByLocation = (input, enabled = true) => {
  const p = buildExtendedDirectoryParams(input);

  return useQuery({
    queryKey: extendedDirectoryKey(p),
    queryFn: ({ signal }) => fetchExtendedDirectoryByLocation({ ...p, signal }),
    enabled: enabled && !!p.gc,
    staleTime: 30_000,
  });
};
